import { format } from 'date-fns'
import { ColumnFilter } from './ColumnFilter'

export const COLUMNS = [
  {
    Header: 'Ref. Nr.',
    Footer: 'Ref. Nr.',
    accessor: 'shipmentRefNo',
    //disableFilters: true,
    sticky: 'left',
    Filter: ColumnFilter,
  },
  {
    Header: 'Datum - Zeit',
    Footer: 'Datum - Zeit',
    accessor: 'timestamp',
    Cell: ({ value }) => {
      return format(new Date(value), 'dd/MM/yyyy')
    },
    Filter: ColumnFilter

  },
  {
    Header: 'Absender',
    Footer: 'Absender',
    accessor: 'shipFromName',
    sticky: 'left',
    Filter: ColumnFilter,
  },
  {
    Header: 'Empfänger',
    Footer: 'Empfänger',
    accessor: 'shipToName',
    sticky: 'left',
    Filter: ColumnFilter
  },
  {
    Header: 'Tracking No.',
    Footer: 'Tracking No.',
    accessor: 'shipmentIdentificationNumber',
    Filter: ColumnFilter
  },
  {
    Header: 'Pickup No.',
    Footer: 'Pickup No.',
    accessor: 'prn',
    Filter: ColumnFilter
  },
  {
    Header: 'shipmentId',
    Footer: 'shipmentId',
    accessor: 'shipmentId'
  },
]

